import gs from '@kk/gs';

function getGS (shareCode: string): Promise<string> {
  return gs(`${process.env.VUE_APP_SIGN_API}/v1/aegis/api/web/challenge?callback=activity${shareCode}`);
}

interface response {
  code: number;
  message: string;
  data: number;
}
interface req {
  shareCode: string;
  verify_provider?: string;
  ticket?: string;
  random?: string;
  uaToken: string;
  webUmidToken: string;
}
interface captchaData {
  ret: number;
  ticket: string;
  CaptchaAppId: string;
  randstr: string;
  errorCode: number;
  errorMessage: string
}
export function joinTeam (shareCode: string, captchaData?: captchaData): Promise<response> {
  return getGS(shareCode).then((sign: string) => {
    const data: req = {
      shareCode,
      uaToken: uabModule.getUA(),
      webUmidToken: webUmidToken
    };
    if (captchaData) {
      data.verify_provider = 'tencent';
      data.ticket = captchaData.ticket;
      data.random = captchaData.randstr;
    }
    return request({
      url: `/gamecard/v2/share/assistance/joinTeam?answer=${sign}`,
      type: 'POST',
      data,
    });
  });
}
  